import React, { Fragment, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import sanitizeHtml from '../../../utils/sanitizeHtml';

import styles from './index.styl';

const ConsentInfo = ({ consent, counter, skipSanitize }) => {
  const { name, typeName, versionTitle, version, content } = consent;

  const subtitle = `${typeName}, ${versionTitle} ${version}`;

  const contentProps = useMemo(() => {
    if (!skipSanitize) {
      return {
        className: styles.text,
        dangerouslySetInnerHTML: {
          __html: sanitizeHtml(content),
        },
      };
    }

    return {
      className: styles.nonSanitizedContent,
      dangerouslySetInnerHTML: {
        __html: content,
      },
    };
  }, [content, skipSanitize]);

  return (
    <Fragment>
      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <div className={styles.mainTitle}>
            <div className={styles.consentTitle}>{name}</div>
            <div className={styles.consentSubTitle}>{subtitle}</div>
          </div>
          {counter && <div className={styles.counter}>{counter}</div>}
        </div>

        <div {...contentProps} />
      </div>
    </Fragment>
  );
};

ConsentInfo.propTypes = {
  consent: PropTypes.object.isRequired,
  counter: PropTypes.node,
  skipSanitize: PropTypes.bool,
};

export default ConsentInfo;



// WEBPACK FOOTER //
// ./src/components/Consents/ConsentInfo/index.jsx